<template>
  <div class="srandardDetail">
    <mainHeader class="mainHeader" @logout="logoutClick" v-if="!isApp"></mainHeader>
    <div class="headTit" v-if="!isApp">
        标准建设
        <span @click="Back()" class="backBtn">返回 ></span>
    </div>
    <div class="main" :style="{marginTop:(isApp ? '0px':'105px')}">
      <iframe id="iframe" ref="iframe" class="frame" :class="isApp?'frame_app':''" scrolling="auto" src="https://cdn.zxzx119.com/jzHH5.html" frameborder='no'></iframe>
    </div>
  </div>
</template>

<script>
import mainHeader from '../../view/header'
export default {
  components: {
    mainHeader
  },
  data () {
    return {
      isApp: false,
      height: '100%'
    }
  },
  mounted () {
    console.log(123132)
    if (parseInt(this.$route.query.isApp) === 1 || parseInt(localStorage.getItem('isApp')) === 1 ||
      parseInt(this.$route.query.isApp) === 2 || parseInt(localStorage.getItem('isApp')) === 2) {
      this.isApp = true
      this.adjustIframe()
    }
  },
  methods: {
    adjustIframe () {
      this.$nextTick(() => {
        this.height = this.$refs.iframe.contentWindow.document.documentElement.scrollHeight
      })
    },
    Back () {
      window.history.go(-1)
    }
  }
}
</script>

<style lang="scss" scoped>
*{
  margin: 0;
  padding: 0;
}
.srandardDetail{
  display: inline-block;
  width: 100%;
  height: 100%;
  background: #f6f6f6;
  font-size: 0;
  /deep/ .mainHeader {
    position: fixed;
    top: 0px;
    height: 55px;
    width: 100%;
    z-index: 500;
  }
  .headTit {
      position: fixed;
      top: 55px;
      left: 0;
      width: 100%;
      height: 50px;
      background: #ffffff;
      padding: 0 14px 0 14px;
      line-height: 40px;
      color: #000000;
      font-size: 15px;
      font-weight: bold;
      border-bottom: 10px solid #f4f4f4;
      .backBtn {
        font-size: 13px;
        color: #999999;
        float: right;
        font-weight: normal;
      }
  }
  .main{
    display: inline-block;
    width: 100vw;
    height: calc(100vh - 110px);
    font-size: 0;
    margin-top: 105px;
    .frame{
      width: 100%;
      height: 100%;
    }
    .frame_app{
      height: calc(100vh - 10px);
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/view/microFireHouse/standardDetail.vue